import React from 'react';
import './ExploreUnknownAflameBurnOverlay.css';

/**
 * Permanent burn VFX for Explore Unknown mission 68 (CREATION) aflame generals and units.
 * @param {{ active?: boolean, variant?: 'card' | 'portrait' | 'minimal', className?: string, style?: object }} props
 */
export function ExploreUnknownAflameBurnOverlay({
  active = true,
  variant = 'card',
  className = '',
  style,
}) {
  if (!active) {
    return null;
  }
  const variantClass =
    variant === 'portrait'
      ? 'eu-aflame-burn-overlay--portrait'
      : variant === 'minimal'
        ? 'eu-aflame-burn-overlay--minimal'
        : 'eu-aflame-burn-overlay--card';

  return (
    <div
      className={`eu-aflame-burn-overlay ${variantClass}${className ? ` ${className}` : ''}`}
      style={style}
      aria-hidden
    >
      <span className="eu-aflame-burn-ember eu-aflame-burn-ember--1" />
      <span className="eu-aflame-burn-ember eu-aflame-burn-ember--2" />
      <span className="eu-aflame-burn-ember eu-aflame-burn-ember--3" />
    </div>
  );
}

export default ExploreUnknownAflameBurnOverlay;
